export const GET_PAST_RECEIPT = 'GET_PAST_RECEIPT';
export const GET_PAST_RECEIPT_REQUEST = 'GET_PAST_RECEIPT_REQUEST';
export const GET_PAST_RECEIPT_RESPONSE = 'GET_PAST_RECEIPT_RESPONSE';
export const GET_PAST_RECEIPT_ERROR = 'GET_PAST_RECEIPT_ERROR';
export const SHOW_PAST_RECEIPT_MEAL_DETAILS = 'SHOW_PAST_RECEIPT_MEAL_DETAILS';
export const HIDE_PAST_RECEIPT_MEAL_DETAILS = 'HIDE_PAST_RECEIPT_MEAL_DETAILS';

import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const getPastReceipt = menuSlug =>
  makeApiRequest({
    requestType: GET_PAST_RECEIPT,
    method: RequestService.getPastReceipt,
    params: { menuSlug: menuSlug },
  });

export const showPastReceiptMealDetails = (mealId, menuSlug, activeTab) => ({
  type: SHOW_PAST_RECEIPT_MEAL_DETAILS,
  mealId,
  menuSlug,
  activeTab,
});

export const hidePastReceiptMealDetails = () => ({
  type: HIDE_PAST_RECEIPT_MEAL_DETAILS,
});
